import React from 'react';
import {Modal, Card, CardHeader, CardContent, CardActions, Button, TextField, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

export default function AttentionModal({
  open,
  animalName,
  onClose,
  onSubmit,
  submitting = false,
  initialSubject = ''
}) {
  const {t} = useTranslation();
  const [subject, setSubject] = React.useState(initialSubject || '');

  React.useEffect(() => {
    if (open) {
      setSubject(initialSubject || '');
    }
  }, [open, initialSubject]);

  const handleSubmit = () => {
    if (onSubmit) onSubmit(subject);
  };

  return (
    <Modal open={!!open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-attention">
      <Card sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        width: 600,
        maxWidth: '90%',
        height: 'auto',
      }}>
        <CardHeader title={<Typography variant="h5">{t('specialAttention') + ' ' + (animalName || '')}</Typography>} />
        <CardContent>
          <TextField
            inputProps={{maxLength: 50}}
            margin="normal"
            required
            fullWidth
            id="aandachtspunt"
            label={t('attentionPoint')}
            name="aandachtspunt"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </CardContent>
        <CardActions>
          <Button onClick={handleSubmit} disabled={submitting || subject === null}>{t('yes')}</Button>
          <Button onClick={onClose} disabled={submitting}>{t('no')}</Button>
        </CardActions>
      </Card>
    </Modal>
  );
}
